import React from "react";
import PropTypes from "prop-types";

import styles from "./resources/styles/spinner.module.scss";

const Spinner = ({ variant, state }) => {
    return (
        <div className={styles.container} variant={variant} state={state}>
            <div className={styles.unit} variant="item-1" />
            <div className={styles.unit} variant="item-2" />
            <div className={styles.unit} variant="item-3" />
            <div className={styles.unit} variant="item-4" />
            <div className={styles.unit} variant="item-5" />
        </div>
    );
};

Spinner.defaultProps = {
    variant: "light",
    state: "hidden",
};

Spinner.propTypes = {
    variant: PropTypes.oneOf(["light", "dark"]),
    state: PropTypes.oneOf(["visible", "hidden"]),
};

export default Spinner;
